var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / timer"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.145 8.69404L21.708 7.13104L20.294 5.71704L18.586 7.42404C17.536 6.79404 16.312 6.42404 15 6.42404C11.141 6.42404 8 9.56404 8 13.424C8 17.284 11.141 20.424 15 20.424C18.859 20.424 22 17.284 22 13.424C21.9992 11.6701 21.3368 9.98095 20.145 8.69404ZM15 18.424C12.243 18.424 10 16.181 10 13.424C10 10.667 12.243 8.42404 15 8.42404C17.757 8.42404 20 10.667 20 13.424C20 16.181 17.757 18.424 15 18.424Z",
    fill: "#292829"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 10.4241H16V14.4241H14V10.4241ZM13 3.42407H17V5.42407H13V3.42407ZM3 8.42407H7V10.4241H3V8.42407ZM3 16.4241H7V18.4241H3V16.4241ZM2 12.4241H5.99V14.4241H2V12.4241Z",
    fill: "#292829"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerIcon);
export default __webpack_public_path__ + "static/media/timer-icon.9bf4131cfbfb1a0d715c45a67213ff33.svg";
export { ForwardRef as ReactComponent };